
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useStorageDownload = () => {
  const [downloading, setDownloading] = useState(false);

  const downloadFile = async (bucket: string, path: string) => {
    setDownloading(true);

    try {
      console.log(`📥 Downloading file from ${bucket}/${path}`);
      
      const { data, error } = await supabase.storage
        .from(bucket)
        .download(path);

      if (error) {
        console.error('❌ Storage download error:', error);
        throw error;
      }

      console.log('✅ File downloaded successfully');
      return data;
    } catch (error) {
      console.error('❌ Download failed:', error);
      toast.error('Failed to download file');
      throw error;
    } finally {
      setDownloading(false);
    }
  };

  const getPublicUrl = (bucket: string, path: string) => {
    const { data } = supabase.storage
      .from(bucket)
      .getPublicUrl(path);
    
    return data.publicUrl;
  };

  const createSignedUrl = async (bucket: string, path: string, expiresIn: number = 3600) => {
    try {
      const { data, error } = await supabase.storage
        .from(bucket)
        .createSignedUrl(path, expiresIn);

      if (error) {
        console.error('❌ Error creating signed URL:', error);
        throw error;
      }

      return data.signedUrl;
    } catch (error) {
      console.error('❌ Failed to create signed URL:', error);
      toast.error('Failed to create signed URL');
      throw error;
    }
  };

  return {
    downloading,
    downloadFile,
    getPublicUrl,
    createSignedUrl,
  };
};
